import { statusFromAwarded } from "@/components/widgets/tradeActionSummary/helper/colDefs/colDefsShared";
import { returnAllTradeDetailsFromGenericParams } from "@/lib/agGridColDefs/colDefGlobalHelpers";
import { ExecutionStrategyStatus } from "@/lib/interfaces and Enums/ENUMExecutionStrategyStatus";
import { QuoteSide } from "@/lib/interfaces and Enums/ENUMQuoteSide";
import { getFlashStyles, FlashKeyframes } from "@/lib/styles/flashStyles";
import tradeDataStore from "@/store/tradeDataStore";
import tradeSettingsStore from "@/store/tradeSettingsStore";
import { getBlockIdForFlash } from "../quoteAndExecuteFunctions/quoteFlashHelper";
import { useTheme } from "next-themes";
import { quoteShade } from "../columnHelpers/quoteShading";
import { formattedQuote } from "../columnHelpers/formattedQuote";

function QuoteCellRenderer(params: any) {
  const { theme } = useTheme();
  const esid = params.fullTradeData.esid
    ? params.fullTradeData.esid
    : params.esid;

  const { isLeg, isER, isES, isOp, fullTradeData, isOutright } =
    returnAllTradeDetailsFromGenericParams(params);

  const thisTrade =
    tradeDataStore((state) =>
      state.tradeData.find((trade) => trade.esid == esid),
    ) ?? fullTradeData;
  let liveStatus;
  if (thisTrade) {
    liveStatus = thisTrade.status as ExecutionStrategyStatus;
  } else {
    liveStatus = params.data.status as ExecutionStrategyStatus;
  }

  let liveQuoteSide = QuoteSide.Both; // default value will always be replaced.
  if (isLeg) {
    if (!isOp) {
      if (statusFromAwarded.includes(liveStatus)) {
        thisTrade?.legs?.forEach((trade) => {
          if (trade.blockId == params.data.blockId) {
            if (trade.quoteSide) {
              liveQuoteSide = trade.quoteSide;
            }
          }
        });
      }
    } else {
      liveQuoteSide = params.data.quoteSide; // OP Always has the quoteSide.
    }
  } else {
    if (!isOp) {
      if (statusFromAwarded.includes(liveStatus) && thisTrade?.quoteSideER) {
        liveQuoteSide = thisTrade.quoteSideER;
      }
    }
  }

  // Flash validation: subscribe to legCellsToFlash
  const legCellsToFlash = tradeSettingsStore(
    (state) => state.legCellsToFlash,
  );

  const blockId = getBlockIdForFlash(isLeg, isER, isOutright, params);
  const columnField = params.colDef?.field;

  const isFlashing =
    blockId != null &&
    legCellsToFlash.some(
      (cell) =>
        cell.esid === esid &&
        cell.blockId == blockId &&
        cell.quoteSide === columnField,
    );

  const flashStyles = getFlashStyles(isFlashing);

  const quoteShadeParams = {
    params,
    theme,
    liveStatus,
    liveQuoteSide,
    isLeg,
    isER,
    isES,
    isOp,
    fullTradeData,
    thisTrade,
  };

  return (
    <>
      <FlashKeyframes isFlashing={isFlashing} />
      <div
        data-testid="QuoteCellRendererContainer"
        id="QuoteCellRendererContainer"
        className={`justify-center flex  text-ellipsis ${!isFlashing ? quoteShade(quoteShadeParams) : ""}`}
        style={isFlashing ? flashStyles : { width: "100%" }}
      >
        {formattedQuote(params, thisTrade)}
      </div>
    </>
  );
}

export default QuoteCellRenderer;
